<template>
    <div class="field field--number" :class="fieldClasses">
        <div class="row collapse no-pad align-middle" v-if="helptext || label">
            <div class="columns shrink" v-if="helptext">
                <help-text :helptext="helptext"></help-text>
            </div>
            <div class="columns" v-if="label">
                <label :class="labelClasses">{{ label }}</label>
            </div>
        </div>
        <div class="row">
            <div class="columns">
                <div>
                    <input type="number"
                        :value="value"
                        :placeholder="placeholder"
                        @input="updateValue($event.target.value)" />
                </div>
            </div>
        </div>
        <div class="row" v-if="hasErrors">
            <div class="columns">
                <ul class="field__errors">
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Dependencies
     */
    import BaseField from './BaseField'
    import HelpText from '../HelpText'

    /**
     * Component
     */
    export default {
        name: 'year-field',
        extends: BaseField,
        components: {
            HelpText
        },
        methods: {
            updateValue (value) {
                let val = !value ? null : Number(value)
                this.$emit('updated', !isNaN(val) ? val : null)
            }
        },
        mounted () {
            this.$nextTick(() => {
                if (this.value === null) {
                    this.updateValue(new Date().getFullYear())
                }
            })
        }
    }
</script>



// WEBPACK FOOTER //
// src/components/general/forms/YearField.vue